import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';

const FeatureSection: FC<{}> = (props) => {
	const { width } = useResizeObserver();
	const { transData, list } = useTranslation('partner.feature');

	const renderList = () => {
		return (list as any[]).map((item, i) => {
			return (
				<div className={styles['ac-feature-item']} key={i} style={{ backgroundColor: item.backgroundColor }}>
					<div className={styles['ac-feature-item-img']}>
						<img src={item.icon} alt="" />
					</div>
					<div className={styles['ac-feature-item-title']}>{item.title}</div>
				</div>
			);
		});
	};

	return (
		<section className={styles['ac-feature']} id="feature">
			{/* <img src="https://web-data.zmlearn.com/image/dxgcsLdZySyNr7QyuKxgj7/img_p4_left%402x.png" alt="" className={styles.img1} /> */}
			{/* <img src="https://web-data.zmlearn.com/image/6pDwXiHrrjHCFoFK4p9o9P/img_p4_right%402x.png" alt="" className={styles.img2} /> */}
			<div className={styles['ac-feature-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				{width >= 768 ? (
					<img
						className={styles['feature-img']}
						loading="lazy"
						src="https://web-data.zmlearn.com/image/3LRvmtoFaxwx5QNphdnGYH/img_P4%402x.png"
						alt=""
					/>
				) : (
					<div className={styles['feature-list']}>{renderList()}</div>
				)}
			</div>
		</section>
	);
};

export default FeatureSection;
